import React from "react";

import { CButton } from "@coreui/react";

const SwitchButton = props => (
  <CButton
    color="white"
    onClick={props.onClick}
    className={`p-0 border-default rounded-pill d-flex align-items-center ${
      props.className || ""
    }`}
    style={{ fontSize: "1rem", ...props.style }}
  >
    <div
      className="bg-orange px-2 py-1"
      style={{
        borderRadius: "inherit",
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      }}
    >
      {props.icon}
    </div>
    <div className="pr-3 pl-2 py-1">{props.text}</div>
  </CButton>
);

export default SwitchButton;
